import { render, staticRenderFns } from "./ClueTendcyCard.vue?vue&type=template&id=a37bf56a&scoped=true&"
import script from "./ClueTendcyCard.vue?vue&type=script&lang=js&"
export * from "./ClueTendcyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37bf56a",
  null
  
)

export default component.exports